import React from 'react';
import Loader from '../components/Loader';

// Fullscreen loader for initial page loads or major state changes
export const FullscreenLoader = ({ text = 'Loading...' }) => (
  <Loader fullScreen overlay text={text} />
);

// Page loader for content areas
export const PageLoader = ({ text = 'Loading content...' }) => (
  <div className="flex justify-center items-center min-h-[400px] w-full">
    <Loader text={text} />
  </div>
);

// Content loader for smaller sections
export const ContentLoader = ({ text = '', size = 'medium' }) => (
  <Loader size={size} text={text} />
);

// Inline loader for buttons or other inline elements
export const InlineLoader = ({ text = '', className = '' }) => (
  <div className={`flex items-center ${className}`}>
    <Loader size="small" text={text} />
  </div>
);

// Button loader with text
export const ButtonLoader = ({ text = 'Processing...' }) => (
  <div className="flex items-center">
    <Loader size="small" />
    <span className="ml-2">{text}</span>
  </div>
);

export default {
  FullscreenLoader,
  PageLoader,
  ContentLoader,
  InlineLoader,
  ButtonLoader,
}; 